"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var constants = _interopRequireWildcard(require("../constants"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  PROVIDER_SPECIALTY_INCLUDES_ALL,
  PROVIDER_KCL_TERMS_INCLUDES_ALL,
  ANSWER_INCLUDES_ALL,
  ANSWER_INCLUDES_ANY,
  COMPOSE_COND
} = constants.predicates;
const predicates = {
  [PROVIDER_SPECIALTY_INCLUDES_ALL]: (ctx, ev, _ref) => {
    var _context, _context2;
    let {
      cond
    } = _ref;
    const itemSet = new _set.default((0, _map.default)(_context = cond.items).call(_context, v => v.toLowerCase()));
    const specialties = (0, _filter.default)(_context2 = ctx.provider.specialties).call(_context2, v => itemSet.has(v.specialty.toLowerCase()));
    return itemSet.size === specialties.length;
  },
  [PROVIDER_KCL_TERMS_INCLUDES_ALL]: (ctx, ev, _ref2) => {
    var _context3, _context4;
    let {
      cond
    } = _ref2;
    const itemSet = new _set.default((0, _map.default)(_context3 = cond.items).call(_context3, v => v.toLowerCase()));
    const terms = (0, _filter.default)(_context4 = ctx.provider.scope_of_practice.concepts).call(_context4, v => {
      var _context5;
      return (0, _find.default)(_context5 = v.terms).call(_context5, term => itemSet.has(term.name.toLowerCase()));
    });
    return itemSet.size === terms.length;
  },
  [ANSWER_INCLUDES_ALL]: (ctx, ev, _ref3) => {
    let {
      cond
    } = _ref3;
    const values = (0, _isArray.default)(ev.value) ? new _set.default(ev.value) : new _set.default([ev.value]);
    const itemSet = new _set.default(cond.items);
    if (itemSet.size !== values.size) {
      return false;
    }
    for (const item of itemSet) {
      if (!values.has(item)) {
        return false;
      }
    }
    return true;
  },
  [ANSWER_INCLUDES_ANY]: (ctx, ev, _ref4) => {
    let {
      cond
    } = _ref4;
    const values = (0, _isArray.default)(ev.value) ? new _set.default(ev.value) : [ev.value];
    const itemSet = new _set.default(cond.items);
    for (const val of values) {
      if (itemSet.has(val)) {
        return true;
      }
    }
    return false;
  },
  range: (ctx, ev, _ref5) => {
    let {
      cond
    } = _ref5;
    const {
      min,
      max
    } = cond;
    return ev.value[0] > min && ev.value[0] < max;
  }
};

/**
 * composeCond is the only guard that should be exported.
 * @usage
 * ```
 *      {
 *        cond: {
 *          type: 'composeCond',
 *          predicates: [
 *              { type: 'answerIncludesAll', items: ['fever'] },
 *              { type: 'providerSpecialtyIncludesAll', items: ['pediatrics'] }
 *          ]
 *        },
 *        target: '#done'
 *      }
 *  ```
 */
const guards = {
  [COMPOSE_COND]: (ctx, ev, _ref6) => {
    let {
      cond
    } = _ref6;
    for (const predicate of cond.predicates) {
      const {
        type,
        ...rest
      } = predicate;
      const isValid = predicates[type](ctx, ev, {
        cond: rest
      });
      if (!isValid) {
        return false;
      }
    }
    return true;
  }
};
var _default = exports.default = guards;